'use client';

/**
 * Theme-Aware Loader Hook
 * Dynamically loads loader component from active theme
 */
import { ComponentType, useEffect, useState } from 'react';

import { Loader as DefaultLoader, LoaderProps } from '@/components/common/Loader';
import { getThemeUIComponent } from '@/core/theme/utils.client';

export function useThemeLoader(themeId: string = 'cray'): ComponentType<LoaderProps> {
  const [LoaderComponent, setLoaderComponent] = useState<ComponentType<LoaderProps>>(() => DefaultLoader);

  useEffect(() => {
    async function loadThemeLoader() {
      const ThemeLoader = await getThemeUIComponent<LoaderProps>('Loader', themeId);
      if (ThemeLoader) {
        setLoaderComponent(() => ThemeLoader);
      }
    }
    loadThemeLoader();
  }, [themeId]);

  return LoaderComponent;
}
